import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Start video emotion analysis for an analysis parent
 */
export function startVideoEmotionAnalysis(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/video-emotion-analysis/start`;
    return axios.post(url, {}, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}

/**
 * Get video emotion analysis results for an analysis parent
 */
export function getVideoEmotionAnalysisResults(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/video-emotion-analysis/results`;
    return axios.get(url, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}

/**
 * Cancel a running video emotion analysis
 */
export function cancelVideoEmotionAnalysis(analysisParentUuid) {
    const url = `${API_BASE_URL}/analysis-parent/${analysisParentUuid}/video-emotion-analysis/cancel`;
    return axios.post(url, {}, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}